<template>
	<div class="main__container">
	    <div class="main__content">

	    	<div v-if="defaultContent == 'about'" class="page-body">
	    		<h1 class="page-title" style="border-bottom: 1px solid #dae2e4; padding-bottom: 20px;">About</h1>
	    		<p>Aafiyat Search is a search engine that makes high-quality nutrition information easily accessible to everyone. Aafiyat Search searches billions of documents from government agencies, global nutrition organizations, nutrition journals, and reference sites.</p>
	    		<p>Our approach increases the visibility of medical information from reputable sources; information that can often be lost in a muddle of commercial results and user-generated content.</p>
	    		<p>Subscription paywalls are commonplace in professional nutrition reference. We recognize that unexpectedly running into those walls can be a headache.</p> 
	    		<p><strong>Site features:</strong></p>
	    		<ul>
	    			<li><a href="/">Nutrition Search Engine</a><br>Search across billions of documents from reputable sources.</li>
	    			<li><a href="/directory/">Nutrition Site Directory</a><br>Directory of over 800 credible nutrition information sites.</li>
	    			<li><a href="/guides">Nutrition Research Guides</a><br>Guides to finding, evaluating, and using online nutrition information.</li>
	    		</ul>
	    		<p>Based in Alor Setar, Aafiyat Search is a collaborative effort involving developers and nutrition professionals from around the world. We hope that this free service is helpful to you in your research.</p>
	    	</div>

	    	<div v-if="defaultContent == 'contact'" class="page-body">
    		    <div v-if="displayMessage" :class="'alert alert-important alert-dismissible alert-' + colorMessage" role="alert" style="margin-bottom: 30px;">
    		        <div class="d-flex">
    		            <div>{{ sendMessage }}</div>
    		        </div>
    		        <a class="btn-close" data-bs-dismiss="alert" aria-label="close" v-on:click="btnCloseAlert"></a>
    		    </div>
	    		<h1 class="page-title" style="border-bottom: 1px solid #dae2e4; padding-bottom: 20px;">Contact</h1>
	    		<p style="margin-bottom:24px;">Please use the form below to report site errors or to send comments, inquiries, and suggestions.</p>
	    		<div id="stylized">
	    			<form method="post" id="formContact" style="display:block">    
	    				<input name="_token" type="hidden" :value="csrfToken">   
	    				<div class="row">
	    					<label style="padding-top:5px;">Name</label>
	    					<input type="text" v-model="inputForm.name" name="name" class="inputfield">
	    				</div>
	    				<div class="row">
	    					<label style="padding-top:5px;">Email</label>
	    					<input type="text" v-model="inputForm.email" name="email" class="inputfield">
	    				</div>
	    				<div class="row">
	    					<label style="padding-top:5px;">Comment</label>
	    					<textarea name="comment" v-model="inputForm.comment" rows="5"></textarea>
	    				</div>
	    				<div class="row">
	    					<input type="button" value="Send" :disabled="validateForm" v-on:click="submitFeedback">
	    				</div>
	    			</form>
	    		</div>
	    	</div>

	    	<div v-if="defaultContent == 'content'" class="page-body">
	    		<h1 class="page-title" style="border-bottom: 1px solid #dae2e4; padding-bottom: 20px;">Content Policy</h1>
	    		<p><span>(https://search.aafiyatgroup.com/) is owned and operated by Aafiyat Holdings Sdn. Bhd.<br>&nbsp;I hereby agree that;</span></p>
	    		<ul style="list-style-type: disc;">
	    		    <li><span>All materials contained on this site, including all designs, drawings, photographs and any other content contained on this site are protected by copyright, trademark or any other proprietary right owned by Aafiyat Holdings Sdn. Bhd., except as otherwise stated.</span></li>
	    		    <li><span>No part of this website may be modified, copied, resubmitted, published, displayed, licensed, transferred, sold or otherwise maintained for commercial purposes in any form without prior written permission of Aafiyat Holdings Sdn. Bhd except for articles which are attached with the sharing button, provided that the user must give appropriate credit to Aafiyat Holdings Sdn. Bhd (with a link to the formal publication of Aafiyat Search)</span></li>
	    		    <li><span>The contents of this website are intended to provide users of this site with nutritional guideline, Islamic references, scientific research, product and company information.&nbsp;</span></li>
	    		    <li><span>The contents of this site are deemed to be accurate and up-to-date and at the date stated on the front page of this site.</span></li>
	    		    <li><span>In addition, careful observation has been made in providing the information on this site and Aafiyat Holdings Sdn. Bhd. will not be liable for any inaccuracies or incomplete information on this site.</span></li>
	    		    <li><span>The last version of any document on this site is a copy of the original documentation filed with Aafiyat Holdings Sdn. Bhd.&nbsp;</span></li>
	    		    <li><span>No part of this site is permitted to link to any of these websites without the prior written permission of Aafiyat Holdings Sdn. Bhd.</span></li>
	    		    <li><span>Any website linked to this site is not under the control of Aafiyat Holdings Sdn. Bhd.</span></li>
	    		    <li><span>Aafiyat Holdings Sdn. Bhd. is not responsible for the content of any linked website, or any changes to that website.</span></li>
	    		    <li><span>Requests for permission to link to this site must be made in writing to Aafiyat Holdings Sdn. Bhd.&nbsp;</span></li>
	    		    <li><span>This site has links to other sites; however, the privacy policy or policy applies only to this website (https://search.aafiyatgroup.com/). Other websites associated with this site may have different privacy policies and visitors are advised to review and understand the privacy policy for each site you visit.</span></li>
	    		</ul>
	    		<p><span>If this website policy changes in any way, it will be updated on this page. Regularly review this page to keep you updated on the information collected</span></p>
	    	</div>

	    </div>
	    <div class="main__sidebar-first" id="reference">
	        <nav class="directory directory--sidebar" style="padding-right: 20px;">
	            <ul class="menu menu--directory">
	                <li :class="checkActiveCategory('about')"><a href="/site/about">About</a></li>
	                <li :class="checkActiveCategory('contact')"><a href="/site/contact">Contact</a></li>
	                <li :class="checkActiveCategory('content')"><a href="/site/content">Content Policy</a></li>
	            </ul>
	        </nav>
	    </div>
	</div>
</template>

<script>
	export default {
        props: ['data'],
        data() {
        	return {
        		defaultMenu: this.data.menu,
        		defaultContent: this.data.menu,
        		inputForm: [{
        			name: "",
        			email: "",
        			comment: "",
        		}],
				csrfToken: "",
				sendMessage: "",
				displayMessage: false,
				submitForm: false,
				colorMessage: "",
        	};
        },  
        methods: {
        	checkActiveCategory(res) {
        		return res == this.defaultMenu ? 'menu__item is-active' : 'menu__item'
        	},
        	toggleActiveCategory (index) {
        		this.defaultMenu = index;
        		this.defaultContent = index;
        	},
        	validEmail: function (email) {
        		var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        		return re.test(email);
        	},
        	submitFeedback() {
				this.submitForm = true;
				const form = new FormData(document.getElementById("formContact"));
				axios.post('/api/ajax/about/contact', form).then(res => {
					this.submitForm = false;
                    this.inputForm.name = "";				    	
                    this.inputForm.email = "";				    	
                    this.inputForm.comment = "";
                    this.colorMessage = res.data.data.color;				    	
					this.sendMessage = res.data.message;
					this.displayMessage = true;
			    })
			    .catch(err => {                    
			    }) 
        	},
        	btnCloseAlert() {
        		this.displayMessage = false;
        	},
        },
        computed: {
        	validateForm() {
        		if (!this.inputForm.name) {
        		    return true;
        		}
        		if (!this.inputForm.email) {
        		    return true;
        		}
        		if (!this.validEmail(this.inputForm.email)) {
        		    return true;
        		}
        		if (!this.inputForm.comment) {
        		    return true;
        		}
        		if (this.submitForm) {
        			return true;
        		}
        	}
        }, 
        mounted() {
			this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;        	
        },      
	}
</script>

<style scoped>
.btn-close {
	position: absolute;
	z-index: 2;
	top: 2px;
	right: 0;
	padding: 1.25rem 1rem;
	background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e") center/.75rem auto no-repeat;
	cursor: pointer;
	opacity: .3;
}
</style>